/**
 * Telugu (India) locale for messaging-ui.
 * Export is the "messaging" subtree for host i18n merge.
 */
import type { MessagingLocale } from './en'

export const messagingTeIn = {
  list: {
    loading: `సందేశ సమూహాలు లోడ్ అవుతున్నాయి...`,
    error: `లోపం`,
    empty: `సందేశ సమూహాలు కనుగొనబడలేదు`,
    emptyDescription: `ఈ PBX కోసం ప్రస్తుతం సందేశ సమూహాలు కాన్ఫిగర్ చేయబడలేదు.`,
    deleteConfirmTitle: `సందేశ సమూహం తొలగించు`,
    deleteConfirm: `మీరు "{{name}}" తొలగించాలనుకుంటున్నారా?`,
    smsEnabled: `ఎనేబుల్ చేయబడింది`,
    smsDisabled: `డిసేబుల్ చేయబడింది`,
    delete: `తొలగించు`,
    columnGroupName: `సమూహం పేరు`,
    columnPrimarySms: `ప్రాథమిక SMS`,
    columnMembers: `సభ్యులు`,
    columnSmsStatus: `SMS స్థితి`,
    columnCreated: `సృష్టించబడింది`,
    columnUpdated: `నవీకరించబడింది`,
    columnActions: `చర్యలు`,
    toast: {
      createdTitle: `సందేశ సమూహం సృష్టించబడింది`,
      createdDescription: `"{{name}}" విజయవంతంగా సృష్టించబడింది.`,
      createFailedTitle: `సృష్టించడం విఫలమైంది`,
      createFailedDescription: `సందేశ సమూహాన్ని సృష్టించడం విఫలమైంది`,
      deletedTitle: `సందేశ సమూహం తొలగించబడింది`,
      deletedDescription: `"{{name}}" తొలగించబడింది.`,
      deleteFailedTitle: `తొలగించడం విఫలమైంది`,
      deleteFailedDescription: `సందేశ సమూహాన్ని తొలగించడం విఫలమైంది`,
    },
    title: `సందేశాలు`,
    createButton: `+ సమూహాన్ని సృష్టించు`,
    searchPlaceholder: `పేరు లేదా ఫోన్ నంబర్ ద్వారా వెతకండి...`,
    noResults: `ఫలితాలు లేవు`,
    noResultsDescription: `"{{search}}"కి సరిపోలే సందేశ సమూహాలు ఏవీ లేవు.`,
    noMembersWarning: `ఈ సమూహంలో సభ్యులు లేరు. కస్టమర్ సందేశాలు చదవబడకపోవచ్చు.`,
  },
  detail: {
    validationErrorTitle: `ధృవీకరణ లోపం`,
    validationErrorDescription: `సమూహం పేరు అవసరం`,
    toast: {
      updatedTitle: `సందేశ సమూహం నవీకరించబడింది`,
      updateFailedTitle: `నవీకరించడం విఫలమైంది`,
      updateFailedDescription: `సందేశ సమూహాన్ని నవీకరించడం విఫలమైంది`,
      smsAddedTitle: `SMS నంబర్ జోడించబడింది`,
      smsAddFailedTitle: `SMS నంబర్ జోడించడం విఫలమైంది`,
      smsRemovedTitle: `SMS నంబర్ తొలగించబడింది`,
      smsRemoveFailedTitle: `SMS నంబర్ తొలగించడం విఫలమైంది`,
      memberAddedTitle: `సభ్యుడు జోడించబడ్డారు`,
      memberAddFailedTitle: `సభ్యుడిని జోడించడం విఫలమైంది`,
      memberAddFailedDescription: `గ్రూప్‌కు సభ్యుడిని జోడించడం విఫలమైంది`,
      memberRemovedTitle: `సభ్యుడు తొలగించబడ్డారు`,
      memberRemoveFailedTitle: `సభ్యుడిని తొలగించడం విఫలమైంది`,
    },
    loading: `సందేశ సమూహం లోడ్ అవుతోంది...`,
    error: `లోపం`,
    notFound: `సందేశ సమూహం కనుగొనబడలేదు.`,
    title: `సందేశ సమూహాన్ని సవరించు`,
    viewTitle: `సందేశ సమూహం`,
    groupNameLabel: `సమూహం పేరు`,
    groupNamePlaceholder: `సమూహం పేరు నమోదు చేయండి`,
    primarySmsLabel: `ప్రాథమిక SMS నంబర్`,
    primarySmsPlaceholder: `ప్రాథమిక SMS నంబర్ ఎంచుకోండి`,
    campaignIdWarning: `ఎంచుకున్న నంబర్‌కు కాంపెయిన్ ID లేదు మరియు టోల్-ఫ్రీ సేవ లేదా కెనడియన్ నంబర్ కాకపోతే SMS పంపలేకపోవచ్చు.`,
    associatedSmsLabel: `ద్వితీయ SMS నంబర్లు`,
    noCampaignId: `(కాంపెయిన్ ID లేదు)`,
    removeSmsAria: `SMS నంబర్ తొలగించు`,
    addSmsNumberAria: `SMS నంబర్ జోడించు`,
    unsavedChanges: `సేవ్ చేయని మార్పులు`,
    campaignSummaryTitle: `{{count}} నంబర్(ల)కు కాంపెయిన్ ID లేదు`,
    campaignSummaryDescription: `ఈ నంబర్లు టోల్-ఫ్రీ లేదా కెనడియన్ నంబర్లు కాకపోతే SMS పంపలేకపోవచ్చు.`,
    backToList: `← జాబితాకు తిరిగి వెళ్ళు`,
    updating: `నవీకరిస్తోంది...`,
    updateButton: `సందేశ సమూహాన్ని నవీకరించు`,
    noMembersWarning: `ఈ సమూహంలో సభ్యులు లేరు. కస్టమర్ సందేశాలు చదవబడకపోవచ్చు.`,
  },
  createModal: {
    validationErrorTitle: `ధృవీకరణ లోపం`,
    validationErrorDescription: `దయచేసి సందేశ సమూహానికి పేరు నమోదు చేయండి`,
    title: `సందేశ సమూహాన్ని సృష్టించు`,
    nameLabel: `సమూహం పేరు`,
    namePlaceholder: `సమూహం పేరు నమోదు చేయండి`,
    primarySmsLabel: `ప్రాథమిక SMS నంబర్`,
    primarySmsPlaceholder: `నంబర్ ఎంచుకోండి`,
    primarySmsRequired: `దయచేసి ప్రాథమిక SMS నంబర్ ఎంచుకోండి`,
    cancel: `రద్దు చేయి`,
    creating: `సృష్టిస్తోంది...`,
    createButton: `సమూహాన్ని సృష్టించు`,
  },
  members: {
    groupMembersTitle: `సమూహ సభ్యులు`,
    emptyGroup: `ఈ సమూహంలో ఇంకా సభ్యులు లేరు.`,
    columnName: `పేరు`,
    columnExtension: `ఎక్స్‌టెన్షన్`,
    columnAdded: `జోడించబడింది`,
    availableMembersTitle: `అందుబాటులో ఉన్న సభ్యులు`,
    emptyAvailable: `జోడించడానికి అందుబాటులో ఉన్న సభ్యులు లేరు.`,
    removeMemberAria: `సభ్యుడిని తొలగించు`,
    addMemberAria: `సభ్యుడిని జోడించు`,
    searchPlaceholder: `పేరు లేదా ఎక్స్‌టెన్షన్ ద్వారా వెతకండి...`,
    noSearchResults: `మీ శోధనకు సరిపోయే సభ్యులు లేరు.`,
  },
  smsModal: {
    validationErrorTitle: `ధృవీకరణ లోపం`,
    validationErrorDescription: `దయచేసి SMS నంబర్ ఎంచుకోండి`,
    title: `అనుబంధ SMS నంబర్లు`,
    label: `అనుబంధ SMS నంబర్లు`,
    loading: `లోడ్ అవుతోంది...`,
    selectPlaceholder: `నంబర్ ఎంచుకోండి`,
    submitting: `సమర్పిస్తోంది...`,
    submit: `సమర్పించు`,
    close: `మూసివేయి`,
  },
  pagination: {
    resultsPerPage: `పేజీకి ఫలితాలు:`,
    previousPage: `మునుపటి పేజీ`,
    nextPage: `తరువాతి పేజీ`,
    jumpToPage: `పేజీ {{page}}కి వెళ్లండి`,
    all: `అన్నీ`,
  },
} satisfies MessagingLocale
